import styled from "styled-components";

export const CreditCardForm = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({styles}) => styles.gap};
  margin-top: ${({styles}) => styles.marginTop};
`;
